// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__NFlSn","navLinks":"navbar_navLinks__Og4oh"};